// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__35Ygj","question":"Question_question__HgOcd","description":"Question_description__1RZ-6"};